/* KORE interactions — cart drawer, predictive search, sticky ATC, zoom, wishlist, reveals. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = c => (window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(c, window.KORE?.moneyFormat) : '$' + (c / 100).toFixed(2));

  /* ---------- scroll reveal ---------- */
  const io = new IntersectionObserver((es) => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .12 });
  const observeReveals = () => $$('[data-reveal]:not(.in)').forEach(el => io.observe(el));
  observeReveals();

  /* ---------- header hide on scroll ---------- */
  const hdr = $('.hdr'); let last = 0;
  addEventListener('scroll', () => {
    const y = scrollY;
    if (hdr) hdr.classList.toggle('hdr--hidden', y > 200 && y > last);
    last = y;
  }, { passive: true });

  /* ---------- overlay + drawers ---------- */
  const overlay = $('#overlay');
  const openEl = el => { el && el.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeAll = () => { $$('.drawer.open').forEach(d => d.classList.remove('open')); overlay && overlay.classList.remove('open'); document.body.style.overflow = ''; };
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => e.key === 'Escape' && closeAll());
  $$('[data-close]').forEach(b => b.addEventListener('click', closeAll));
  $$('[data-open]').forEach(b => b.addEventListener('click', () => openEl($('#' + b.dataset.open))));

  /* ---------- cart drawer ---------- */
  async function refreshCart() {
    const r = await fetch('/cart.js'); const c = await r.json();
    $$('[data-cart-count]').forEach(n => { n.textContent = c.item_count; n.style.display = c.item_count ? 'grid' : 'none'; });
    const body = $('#cart-drawer-body'); if (!body) return c;
    if (!c.items.length) { body.innerHTML = '<p class="muted" style="padding:40px 0">Your cart is empty.</p>'; }
    else {
      body.innerHTML = c.items.map(i => `
        <div class="cart-line" data-key="${i.key}">
          <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="${i.product_title}">
          <div><div class="pcard__title">${i.product_title}</div>
            <div class="muted" style="font-size:13px">${i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : ''}</div>
            <div class="qty" style="margin-top:10px">
              <button data-dec>−</button><input value="${i.quantity}" data-qty readonly><button data-inc>+</button>
            </div></div>
          <div style="text-align:right"><div>${money(i.final_line_price)}</div>
            <button class="link-underline" data-remove style="font-size:11px;margin-top:8px">Remove</button></div>
        </div>`).join('');
    }
    const sub = $('#cart-subtotal'); if (sub) sub.textContent = money(c.total_price);
    return c;
  }
  async function change(key, qty) {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    refreshCart();
  }
  document.addEventListener('click', e => {
    const line = e.target.closest('.cart-line'); if (!line) return;
    const key = line.dataset.key, input = $('[data-qty]', line), q = parseInt(input.value, 10);
    if (e.target.matches('[data-inc]')) change(key, q + 1);
    if (e.target.matches('[data-dec]')) change(key, Math.max(0, q - 1));
    if (e.target.matches('[data-remove]')) change(key, 0);
  });
  // add to cart (any form.js-atc)
  $$('form[data-atc]').forEach(f => f.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); const label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true;
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: f.querySelector('[name=id]').value, quantity: f.querySelector('[name=quantity]')?.value || 1 }) });
    btn.disabled = false; btn.textContent = res.ok ? 'Added ✓' : 'Sold out';
    setTimeout(() => btn.textContent = label, 1400);
    await refreshCart(); openEl($('#cart-drawer'));
  }));
  refreshCart();

  /* ---------- predictive search ---------- */
  const sInput = $('#predictive-input'), sResults = $('#predictive-results');
  let t;
  sInput && sInput.addEventListener('input', () => {
    clearTimeout(t); const q = sInput.value.trim();
    if (q.length < 2) { sResults.innerHTML = ''; return; }
    t = setTimeout(async () => {
      const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive`);
      const d = await r.json().catch(() => null);
      const items = d?.resources?.results?.products || [];
      sResults.innerHTML = items.length ? items.map(p => `
        <a class="cart-line" href="${p.url}" style="grid-template-columns:64px 1fr">
          <img src="${p.image ? p.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : (p.featured_image?.url || '')}" alt="">
          <div><div class="pcard__title">${p.title}</div><div class="muted">${p.price ? money(+p.price) : ''}</div></div>
        </a>`).join('') : '<p class="muted" style="padding:20px 0">No matches.</p>';
    }, 220);
  });

  /* ---------- wishlist (localStorage) ---------- */
  const WK = 'kore_wishlist';
  const wl = () => JSON.parse(localStorage.getItem(WK) || '[]');
  const setWl = a => { localStorage.setItem(WK, JSON.stringify(a)); $$('[data-wish-count]').forEach(n => n.textContent = a.length); };
  window.KOREtoggleWish = (id, el) => { let a = wl(); a = a.includes(id) ? a.filter(x => x !== id) : a.concat(id); setWl(a); el && el.classList.toggle('active', a.includes(id)); };
  setWl(wl());

  /* ---------- recently viewed ---------- */
  if (window.KORE?.product) {
    const RK = 'kore_recent'; let a = JSON.parse(localStorage.getItem(RK) || '[]');
    a = [window.KORE.product.handle, ...a.filter(h => h !== window.KORE.product.handle)].slice(0, 8);
    localStorage.setItem(RK, JSON.stringify(a));
  }

  /* ---------- sticky ATC ---------- */
  const atc = $('#sticky-atc'), buyBox = $('#buybox');
  if (atc && buyBox) {
    const so = new IntersectionObserver(es => es.forEach(e => atc.classList.toggle('show', !e.isIntersecting && scrollY > 500)), { threshold: 0 });
    so.observe(buyBox);
  }

  /* ---------- pdp gallery zoom + thumb select ---------- */
  $$('[data-zoom]').forEach(img => img.addEventListener('click', () => {
    const o = document.createElement('div'); o.className = 'overlay open'; o.style.zIndex = 200;
    o.innerHTML = `<img src="${img.dataset.zoom || img.src}" style="position:absolute;inset:0;margin:auto;max-width:96%;max-height:96%;object-fit:contain">`;
    o.addEventListener('click', () => o.remove()); document.body.appendChild(o);
  }));

  observeReveals();
})();
